import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32', // Forest green as primary color
      light: '#4caf50', // Lighter green variant
      dark: '#1b5e20', // Darker green variant
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#bdbdbd', // Light grey as secondary color
      light: '#e0e0e0', // Lighter grey variant
      dark: '#9e9e9e', // Darker grey variant
      contrastText: '#212121' // Dark text for contrast with light grey
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff'
    },
    text: {
      primary: '#212121',
      secondary: '#757575'
    }
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          borderRadius: 4,
          textTransform: 'none',
          fontWeight: 500
        }
      }
    }
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    button: {
      fontWeight: 500
    }
  }
});

export default theme;